import { db } from "services/firebase";

function asDate(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  if (value.seconds != null) return new Date(value.seconds * 1000);
  return null;
}

function mapNotificationDoc(collection, doc) {
  return {
    id: doc.id,
    collection,
    ...doc.data(),
    createdAtDate: asDate(doc.data()?.createdAt || doc.data()?.promotedAt),
  };
}

export async function listUserNotifications({ uid, limit = 20 }) {
  if (!uid) return [];

  const [fdeC, tciManager, fdeT] = await Promise.all([
    db.collection("fdeCNotifications").where("uid", "==", uid).limit(limit).get(),
    db.collection("tciManagerAlerts").where("tciManagerUid", "==", uid).limit(limit).get(),
    db.collection("fdeTAlerts").where("uid", "==", uid).limit(limit).get(),
  ]);

  const rows = [
    ...fdeC.docs.map((doc) => mapNotificationDoc("fdeCNotifications", doc)),
    ...tciManager.docs.map((doc) => mapNotificationDoc("tciManagerAlerts", doc)),
    ...fdeT.docs.map((doc) => mapNotificationDoc("fdeTAlerts", doc)),
  ];

  return rows
    .sort((a, b) => (b.createdAtDate?.getTime() || 0) - (a.createdAtDate?.getTime() || 0))
    .slice(0, limit);
}

export async function markNotificationRead({ collection, notificationId }) {
  if (!collection || !notificationId) return;
  await db.collection(collection).doc(notificationId).update({ read: true });
}
